import React, { useState, useEffect } from 'react';
import { SaveIcon as Save, CloseIcon as X, EditIcon as Edit2 } from './Icons';

const InlineFieldEditor = ({ 
    value, 
    onSave, 
    onCancel, 
    type = 'text', 
    label, 
    placeholder,
    maxLength,
    rows = 4
}) => {
    const [currentValue, setCurrentValue] = useState(value);

    const handleSave = () => {
        onSave(currentValue);
    };

    const inputClasses = "w-full bg-surface-containerLowest border border-outlineVariant/30 rounded-xl px-4 py-3 text-surface-on focus:outline-none focus:border-primary transition-colors font-medium";

    return (
        <div className="animate-fade-in space-y-4 p-4 rounded-2xl bg-surface-container border border-primary/20 shadow-elevation-1">
            <div className="flex items-center justify-between gap-4">
                <span className="text-label-medium font-bold text-primary uppercase tracking-wider">{label}</span>
                <div className="flex items-center gap-2">
                    <button 
                        onClick={onCancel}
                        className="p-2 rounded-lg hover:bg-surface-containerHigh text-surface-onVariant transition-colors"
                        title="Abbrechen"
                    >
                        <X size={18} />
                    </button>
                    <button 
                        onClick={handleSave}
                        className="px-4 py-2 rounded-lg bg-primary text-primary-on font-bold text-label-medium flex items-center gap-2 hover:bg-primary-hover transition-colors shadow-sm"
                    >
                        <Save size={16} />
                        Speichern
                    </button>
                </div>
            </div>
            
            {type === 'textarea' ? (
                <textarea
                    autoFocus
                    value={currentValue}
                    onChange={(e) => setCurrentValue(e.target.value)}
                    className={`${inputClasses} resize-none`}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    rows={rows}
                />
            ) : (
                <input
                    autoFocus
                    type={type}
                    value={currentValue}
                    onChange={(e) => setCurrentValue(e.target.value)}
                    className={inputClasses}
                    placeholder={placeholder}
                    maxLength={maxLength}
                />
            )}
            
            {maxLength && (
                <div className="flex justify-end">
                    <span className="text-[10px] font-medium text-surface-onVariant/60 italic">
                        {currentValue.length} / {maxLength} Zeichen
                    </span>
                </div>
            )}
        </div>
    );
};

export const EditButton = ({ onClick, className = "" }) => (
    <button
        onClick={(e) => {
            e.stopPropagation();
            onClick();
        }}
        className={`ml-2 p-1.5 rounded-full bg-primary/10 text-primary hover:bg-primary hover:text-white transition-all transform hover:scale-110 shadow-sm border border-primary/20 group ${className}`}
        title="Bearbeiten"
    >
        <Edit2 size={14} className="group-hover:rotate-12 transition-transform" />
    </button>
);

export default InlineFieldEditor;
